import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src", "width", "height"];
import { ref, watch, onMounted, watchEffect } from '../../../../adapter-vue';
import { isPC } from '../../../../utils/env';
import { handleSkeletonSize } from '../../utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-image',
  props: {
    content: {
      default: () => ({})
    },
    messageItem: {
      default: () => ({})
    }
  },
  emits: ['previewImage'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var skeletonDomRef = ref();
    onMounted(() => {
      var _props$messageItem, _props$messageItem2, _props$messageItem3;
      if (((_props$messageItem = props.messageItem) === null || _props$messageItem === void 0 ? void 0 : _props$messageItem.status) === 'success' || ((_props$messageItem2 = props.messageItem) === null || _props$messageItem2 === void 0 ? void 0 : _props$messageItem2.status) === 'fail' || ((_props$messageItem3 = props.messageItem) === null || _props$messageItem3 === void 0 ? void 0 : _props$messageItem3.progress) === 1) {
        autoFixSkeletonSize();
      }
    });
    watch(() => props.content.height, (newVal, oldVal) => {
      if (newVal > oldVal) {
        autoFixSkeletonSize();
      }
    });
    function autoFixSkeletonSize() {
      var _document$getElementB, _skeletonDomRef$value, _skeletonDomRef$value2;
      var {
        width = 0,
        height = 0
      } = props.content;
      if (width === 0 || height === 0) return;
      var containerWidth = ((_document$getElementB = document.getElementById('app')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) || 0;
      var max = !isPC ? Math.min(containerWidth - 180, 300) : 300;
      var size = handleSkeletonSize(width, height, max, max);
      (skeletonDomRef === null || skeletonDomRef === void 0 || (_skeletonDomRef$value = skeletonDomRef.value) === null || _skeletonDomRef$value === void 0 ? void 0 : _skeletonDomRef$value.style) && (skeletonDomRef.value.style.width = "".concat(size.width, "px"));
      (skeletonDomRef === null || skeletonDomRef === void 0 || (_skeletonDomRef$value2 = skeletonDomRef.value) === null || _skeletonDomRef$value2 === void 0 ? void 0 : _skeletonDomRef$value2.style) && (skeletonDomRef.value.style.height = "".concat(size.height, "px"));
    }
    function toggleShow() {
      var _props$messageItem4, _props$messageItem5;
      if (((_props$messageItem4 = props.messageItem) === null || _props$messageItem4 === void 0 ? void 0 : _props$messageItem4.status) === 'success' || ((_props$messageItem5 = props.messageItem) === null || _props$messageItem5 === void 0 ? void 0 : _props$messageItem5.progress) === 1) {
        emits('previewImage', props.messageItem);
      }
    }
    watchEffect(() => {
      console.log("propsss->", props.content);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "skeletonDomRef",
        ref: skeletonDomRef,
        class: "image-container",
        onClick: _withModifiers(toggleShow, ["self"])
      }, [_createElementVNode("img", {
        class: _normalizeClass(['message-image', !_unref(isPC) && 'message-image-h5']),
        src: props.content.url,
        width: props.content.width,
        height: props.content.height
      }, null, 10, _hoisted_1)], 512);
    };
  }
});